import { apiClient } from "../../base/ApiClient";

// Weight Apis
export const createWeight = async (formData) => {
  return await apiClient.post(`/observations/weight/`, formData);
};

export const getWeightByClientID = async (clientID) => {
  const response = await apiClient.get(
    `/observations/weight/?client_id=${clientID}`
  );
  return response.data;
};

export const getWeightByID = async (ID) => {
  const response = await apiClient.get(`/observations/weight/${ID}/`);
  return response.data;
};

export const updateWeight = async (ID, formData) => {
  return await apiClient.put(`/observations/weight/${ID}/`, formData);
};

export const deleteWeightByID = async (ID) => {
  const response = await apiClient.delete(`/observations/weight/${ID}/`);
  return response.data;
};

// Wellbeing Apis
export const createWellbeing = async (formData) => {
  const response = await apiClient.post(`/observations/wellbeing/`, formData);
  return response;
};

export const getWellbeingByClientID = async (clientID) => {
  const response = await apiClient.get(
    `/observations/wellbeing/?client_id=${clientID}`
  );
  return response.data;
};

export const getWellbeingByID = async (ID) => {
  const response = await apiClient.get(`/observations/wellbeing/${ID}/`);
  return response.data;
};

export const updateWellbeing = async (ID, formData) => {
  const response = await apiClient.put(
    `/observations/wellbeing/${ID}/`,
    formData
  );
  return response.data;
};

export const deleteWellbeingByID = async (ID) => {
  const response = await apiClient.delete(`/observations/wellbeing/${ID}/`);
  return response.data;
};

// Assessment Apis
export const createAssessment = async (formData) => {
  const response = await apiClient.post(`/observations/assessment/`, formData);
  return response;
};

export const getAssessmentByClientID = async (clientID, assessment_type) => {
  const response = await apiClient.get(
    `/observations/assessment/?client_id=${clientID}&assessment_type=${assessment_type}`
  );
  return response.data;
};

export const getAssessmentByID = async (ID) => {
  const response = await apiClient.get(`/observations/assessment/${ID}/`);
  return response.data;
};

export const updateAssessment = async (ID, formData) => {
  const response = await apiClient.put(
    `/observations/assessment/${ID}/`,
    formData
  );
  return response.data;
};

export const deleteAssessmentID = async (ID) => {
  const response = await apiClient.delete(`/observations/assessment/${ID}/`);
  return response.data;
};

// Secondary Assessment Apis
export const createSecAssessment = async (formData) => {
  const response = await apiClient.post(
    `/observations/secondary-assessment/`,
    formData
  );
  return response;
};

export const getSecAssessmentByClientID = async (clientID, assessment_type) => {
  const response = await apiClient.get(
    `/observations/secondary-assessment/?client_id=${clientID}&assessment_type=${assessment_type}`
  );
  return response.data;
};

export const getSecAssessmentByID = async (ID) => {
  const response = await apiClient.get(
    `/observations/secondary-assessment/${ID}/`
  );
  return response.data;
};

export const updateSecAssessment = async (ID, formData) => {
  const response = await apiClient.patch(
    `/observations/secondary-assessment/${ID}/`,
    formData
  );
  return response.data;
};

export const deleteSecAssessmentID = async (ID) => {
  const response = await apiClient.delete(
    `/observations/secondary-assessment/${ID}/`
  );
  return response.data;
};

// Infection
export const createAbcPattern = async (formData) => {
  return await apiClient.post(`/observations/abc-reports/`, formData);
};

export const getAbcPattern = async (clientID) => {
  const response = await apiClient.get(
    `/observations/abc-reports/?client_id=${clientID}`
  );
  return response.data;
};

export const getAbcPatternById = async (ID) => {
  const response = await apiClient.get(`/observations/abc-reports/${ID}/`);
  return response.data;
};

export const updateAbcPattern = async (ID, formData) => {
  return await apiClient.put(`/observations/abc-reports/${ID}/`, formData);
};

export const deleteAbcPatternById = async (ID) => {
  const response = await apiClient.delete(`/observations/abc-reports/${ID}/`);
  return response.data;
};

// seizure chart
export const createSeizure = async (formData) => {
  return await apiClient.post(`/observations/seizure-reports/`, formData);
};

export const getSeizure = async (clientID) => {
  const response = await apiClient.get(
    `/observations/seizure-reports/?client_id=${clientID}`
  );
  return response.data;
};

export const getSeizureById = async (ID) => {
  const response = await apiClient.get(`/observations/seizure-reports/${ID}/`);
  return response.data;
};

export const updateSeizure = async (ID, formData) => {
  return await apiClient.put(`/observations/seizure-reports/${ID}/`, formData);
};

export const deleteSeizureById = async (ID) => {
  const response = await apiClient.delete(
    `/observations/seizure-reports/${ID}/`
  );
  return response.data;
};

// Urinalysis
export const createUrinalysis = async (formData) => {
  return await apiClient.post(`/observations/urinalysis/`, formData);
};

export const getUrinalysis = async (clientID) => {
  const response = await apiClient.get(
    `/observations/urinalysis/?client_id=${clientID}`
  );
  return response.data;
};

export const getUrinalysisById = async (ID) => {
  const response = await apiClient.get(`/observations/urinalysis/${ID}/`);
  return response.data;
};

export const updateUrinalysis = async (ID, formData) => {
  return await apiClient.put(`/observations/urinalysis/${ID}/`, formData);
};

export const deleteUrinalysisById = async (ID) => {
  const response = await apiClient.delete(`/observations/urinalysis/${ID}/`);
  return response.data;
};

// Infection
export const createInfection = async (formData) => {
  return await apiClient.post(`/observations/infection-reports/`, formData);
};

export const getInfection = async (clientID) => {
  const response = await apiClient.get(
    `/observations/infection-reports/?client_id=${clientID}`
  );
  return response.data;
};

export const getInfectionById = async (ID) => {
  const response = await apiClient.get(
    `/observations/infection-reports/${ID}/`
  );
  return response.data;
};

export const updateInfection = async (ID, formData) => {
  return await apiClient.put(
    `/observations/infection-reports/${ID}/`,
    formData
  );
};

export const deleteInfectionById = async (ID) => {
  const response = await apiClient.delete(
    `/observations/infection-reports/${ID}/`
  );
  return response.data;
};

export const createNEWS2 = async (formData) => {
  const response = await apiClient.post(`/observations/news2/`, formData);
  return response;
};

export const getNEWS2 = async (page, clientID, location) => {
  const params = new URLSearchParams();
  if (clientID) params.append("client_id", clientID);
  if (location) params.append("location", location);
  params.append("page", page);
  const response = await apiClient.get(
    `/observations/news2/?${params.toString()}`
  );

  return response.data;
};

// Blood Pressure
export const createBloodPressure = async (formData) => {
  const response = await apiClient.post(`/observations/blood-pressure/`, formData);
  return response;
};

export const getBloodPressureByClient = async (clientID) => {
  const response = await apiClient.get(`/observations/blood-pressure/?client=${clientID}`);
  return response.data;
};

export const updateBloodPressure = async (id, formData) => {
  const response = await apiClient.patch(`/observations/blood-pressure/${id}/`, formData);
  return response;
};

export const deleteBloodPressure = async (id) => {
  const response = await apiClient.delete(`/observations/blood-pressure/${id}/`);
  return response;
};